import React from 'react'
import Main from '../components/BranchChange/Main'

const BranchChange = () => {
  return (
    <div>
        <Main/>
    </div>
  )
}

export default BranchChange